export default __webpack_public_path__ + "img-torre-3.5491e4b.svg";